import { useAuthStore } from '@/stores/auth'
import { RouteRecordRaw } from 'vue-router'

export default {
	path: '/account',
	children: [
		{
			// Atajo para que el usuario pueda llegar a su perfil con /account
			// sin tener que conocer su id. Redirige al show correcto según si
			// el usuario es interno o externo.
			path: '',
			name: 'account.profile',
			beforeEnter: (to, from, next) => {
				const authStore = useAuthStore()
				const user = authStore.user
				if (!user) return next({ path: '/auth/login' })
				return next({
					name: user.internal ? 'users.show.internal' : 'users.show',
					params: { id: String(user.id) },
					replace: true,
				})
			},
			component: () => import('@/modules/account/pages/AccountLoadingPage.vue'),
			meta: { authRequired: true },
		},
		{
			path: 'reset-password/get-email',
			name: 'account.reset-password.get-email',
			component: () =>
				import('@/modules/account/pages/PasswordResetEmailPage.vue'),
		},
		{
			path: 'reset-password',
			name: 'account.reset-password',
			component: () => import('@/modules/account/pages/ResetPasswordPage.vue'),
		},
	],
	meta: {
		authRequired: false,
	},
} as RouteRecordRaw
